export const environment = {
	serverUrl: 'https://qa-api.deck-of-dice-games.net'
};